import React, { useCallback, useMemo } from 'react';
import {
	CommandActionType,
	type CommandAction,
	type RenderChildrenProps,
} from '@atlassian/jira-command-palette';
import type { CommandIssue } from '@atlassian/jira-command-palette-common';
import { IssueActionsBody } from './issue-actions-body';

export const useIssueCommandAction = () => {
	const getIssueCommandAction = useCallback((issue: CommandIssue): CommandAction => {
		const action: CommandAction = {
			type: CommandActionType.COMMAND_LIST,
			components: {
				Body: (props: RenderChildrenProps) => (
					<IssueActionsBody issueKey={issue.issueKey} issueId={issue.issueId} {...props} />
				),
			},
		};
		return action;
	}, []);

	return useMemo(() => ({ getIssueCommandAction }), [getIssueCommandAction]);
};
